var path = 'scripts/views/components/line-item-details-field-dropdown.html';
var html = "<div>\n    <select class=\"form-control inline-blk width-90 float-left form-control-dropdown line-item-details-field-dropdown\"\n            ng-model=\"$ctrl.selectedField\"\n            ng-model-options=\"{getterSetter: true}\"\n            ng-options=\"field as ('lineItems.fieldDropdown.' + field | translate) for field in $ctrl.availableFields track by field\">\n    </select>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/line-item-details-field-dropdown.html
// module id = 318
// module chunks = 0